export default "__VITE_ASSET__8ba9ab46__"